<template>
	<button class="button" @click="click">
		<slot></slot>
	</button>
</template>

<script>
import soundFx from '@/mixins/sound-fx';

export default {
	mixins: [soundFx],
	props: {
		action: {
			type: Function,
			required: true,
		},
	},
	methods: {
		click() {
			this.playRandomSound("clicks");
			this.action();
		},
	},
};
</script>

<style lang="scss" scoped>
	.button {
		display: block;
		padding: 0 1.25em;
		border-radius: 10em;

		font-size: 34px;
		font-weight: 700;
		letter-spacing: .07em;
		text-transform: uppercase;
		color: $brand-color-primary;

		border: 3px solid #fff;
		cursor: pointer;
		background: #fff;
		transition: all $ui-transition-duration;

		&:hover {
			background: $gray-light;
			border-color: $gray-light;
		}

		&:focus ,
		&:active {
			border: 3px solid $gray-light;
			outline: none;
		}

		@include mobile {
			font-size: 24px;
		}

		&.dark {
			background: $brand-color-primary-dark;
			border-color: $brand-color-primary-dark;
			color: #fff;

			&:hover {
				background: $brand-color-primary-extra-dark;
				border-color: $brand-color-primary-extra-dark;
			}

			&:focus ,
			&:active {
				border: 3px solid $brand-color-primary-extra-dark;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Button.vue